// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProjectContactsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ProjectContactsQuery = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', id: string, contacts: Array<{ __typename?: 'ProjectContact', id: string, fullName: string, phoneNumber: string, email: string, warrantyTickets: Array<{ __typename?: 'WarrantyTicket', id: string }> }> }
    | { __typename?: 'Region', id: string, contacts: Array<{ __typename?: 'ProjectContact', id: string, fullName: string, phoneNumber: string, email: string, warrantyTickets: Array<{ __typename?: 'WarrantyTicket', id: string }> }> }
    | { __typename?: 'Market', id: string, contacts: Array<{ __typename?: 'ProjectContact', id: string, fullName: string, phoneNumber: string, email: string, warrantyTickets: Array<{ __typename?: 'WarrantyTicket', id: string }> }> }
    | { __typename?: 'Community', id: string, contacts: Array<{ __typename?: 'ProjectContact', id: string, fullName: string, phoneNumber: string, email: string, warrantyTickets: Array<{ __typename?: 'WarrantyTicket', id: string }> }> }
    | { __typename?: 'Subdivision', id: string, contacts: Array<{ __typename?: 'ProjectContact', id: string, fullName: string, phoneNumber: string, email: string, warrantyTickets: Array<{ __typename?: 'WarrantyTicket', id: string }> }> }
    | { __typename?: 'Lot', id: string, contacts: Array<{ __typename?: 'ProjectContact', id: string, fullName: string, phoneNumber: string, email: string, warrantyTickets: Array<{ __typename?: 'WarrantyTicket', id: string }> }> }
    | { __typename?: 'Structure', id: string, contacts: Array<{ __typename?: 'ProjectContact', id: string, fullName: string, phoneNumber: string, email: string, warrantyTickets: Array<{ __typename?: 'WarrantyTicket', id: string }> }> }
    | { __typename?: 'Unit', id: string, contacts: Array<{ __typename?: 'ProjectContact', id: string, fullName: string, phoneNumber: string, email: string, warrantyTickets: Array<{ __typename?: 'WarrantyTicket', id: string }> }> }
   };

export type SaveProjectContactWarrantyMutationVariables = Types.Exact<{
  input: Types.SaveProjectContactInput;
}>;


export type SaveProjectContactWarrantyMutation = { __typename?: 'Mutation', saveProjectContact: { __typename?: 'SaveProjectContactResult', projectContact: { __typename?: 'ProjectContact', id: string } } };

export type WarrantyProjectContactFragment = { __typename?: 'ProjectContact', id: string, fullName: string, phoneNumber: string, email: string, warrantyTickets: Array<{ __typename?: 'WarrantyTicket', id: string }> };

export const WarrantyProjectContactFragmentDoc = gql`
    fragment WarrantyProjectContact on ProjectContact {
  id
  fullName
  phoneNumber
  email
  warrantyTickets {
    id
  }
}
    `;
export const ProjectContactsDocument = gql`
    query ProjectContacts($projectId: ID!) {
  project(id: $projectId) {
    id
    contacts {
      ...WarrantyProjectContact
    }
  }
}
    ${WarrantyProjectContactFragmentDoc}`;

/**
 * __useProjectContactsQuery__
 *
 * To run a query within a React component, call `useProjectContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectContactsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectContactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectContactsQuery, ProjectContactsQueryVariables> & ({ variables: ProjectContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectContactsQuery, ProjectContactsQueryVariables>(ProjectContactsDocument, options);
      }
export function useProjectContactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectContactsQuery, ProjectContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectContactsQuery, ProjectContactsQueryVariables>(ProjectContactsDocument, options);
        }
// @ts-ignore
export function useProjectContactsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectContactsQuery, ProjectContactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectContactsQuery, ProjectContactsQueryVariables>;
export function useProjectContactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectContactsQuery, ProjectContactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectContactsQuery | undefined, ProjectContactsQueryVariables>;
export function useProjectContactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectContactsQuery, ProjectContactsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectContactsQuery, ProjectContactsQueryVariables>(ProjectContactsDocument, options);
        }
export type ProjectContactsQueryHookResult = ReturnType<typeof useProjectContactsQuery>;
export type ProjectContactsLazyQueryHookResult = ReturnType<typeof useProjectContactsLazyQuery>;
export type ProjectContactsSuspenseQueryHookResult = ReturnType<typeof useProjectContactsSuspenseQuery>;
export type ProjectContactsQueryResult = ApolloReactCommon.QueryResult<ProjectContactsQuery, ProjectContactsQueryVariables>;
export const SaveProjectContactWarrantyDocument = gql`
    mutation SaveProjectContactWarranty($input: SaveProjectContactInput!) {
  saveProjectContact(input: $input) {
    projectContact {
      id
    }
  }
}
    `;

/**
 * __useSaveProjectContactWarrantyMutation__
 *
 * To run a mutation, you first call `useSaveProjectContactWarrantyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProjectContactWarrantyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProjectContactWarrantyMutation, { data, loading, error }] = useSaveProjectContactWarrantyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProjectContactWarrantyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveProjectContactWarrantyMutation, SaveProjectContactWarrantyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveProjectContactWarrantyMutation, SaveProjectContactWarrantyMutationVariables>(SaveProjectContactWarrantyDocument, options);
      }
export type SaveProjectContactWarrantyMutationHookResult = ReturnType<typeof useSaveProjectContactWarrantyMutation>;
export type SaveProjectContactWarrantyMutationResult = ApolloReactCommon.MutationResult<SaveProjectContactWarrantyMutation>;